var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',[_c('NavbarTop'),_c('b-row',[_c('SidebarLeft')],1),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1):_c('div',[_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }